<table class="answers-table">
  <thead>
    <tr>
      <th></th>
      <th *ngFor="let c of columns; trackBy: trackCol" class="user" [class.recipient]="c.isRecipient">
        <img *ngIf="c.imageUrl" [src]="c.imageUrl ?? 'assets/profile_image.png'" alt="" />
        <div class="extra-small">{{ c.name }}</div>
      </th>
    </tr>
  </thead>

  <tbody>
    <tr *ngFor="let r of rows; trackBy: trackRow" [class.highlight]="hasPicked(r)">
      <td class="medium bold">{{ r.label }}</td>
      <td *ngFor="let c of columns; trackBy: trackCol" class="cell" [class.recipient]="c.isRecipient">
        <mat-icon *ngIf="picked(r, c)" aria-hidden="true">check</mat-icon>
      </td>
    </tr>
  </tbody>
</table>
